<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import OldSingleFileUploadTemplate from './Old/OldSingleFileUploadTemplate.vue'
import NewSingleFileUploadTemplate from './New/NewSingleFileUploadTemplate.vue'

const current = useUiWrapper(OldSingleFileUploadTemplate, NewSingleFileUploadTemplate)
</script>
